import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import store from '@/store';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    component: () => import('@/views/Auth/LoginViewPage.vue')
  },
  {
    path: '/register/:code',
    component: () => import('@/views/Auth/RegisterViewPage.vue'),
    beforeEnter: async (to, from, next) => {
      const code = to.params.code;
      if (code) {
        next(); // Si el código es válido, permite el acceso a la vista de registro
      } else {
        // Si el código no es válido, redirige a otra página o muestra un mensaje de error
        next('/error');
      }
    },
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/error',
    component: () => import('@/views/Auth/ErrorViewPage.vue')
  },
  {
    path: '/content/',
    component: () => import('@/views/tabs/TabsPage.vue'),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: '',
        redirect: '/content/home'
      },
      {
        path: 'home',
        component: () => import('@/views/tabs/HomePage.vue')
      },
      {
        path: 'generator',
        component: () => import('@/views/tabs/GeneratorPage.vue')
      },
      // TODO: Habilitar cuando esté implementado (Slides / Competición)
      {
        path: 'slides',
        component: () => import('@/views/slides/SlidesPage.vue')
      },
      {
        path: 'event',
        component: () => import('@/views/slides/EventListPage.vue')
      },
      {
        path: 'competitors',
        component: () => import('@/views/slides/CompetitorsPage.vue')
      },
      {
        path: 'competition',
        component: () => import('@/views/slides/CompetitionPage.vue')
      },
      {
        path: 'slides/matrix',
        component: () => import('@/views/slides/options/MatrixViewPage.vue')
      },
      {
        path: 'slides/options',
        component: () => import('@/views/slides/options/OptionsViewPage.vue')
      },
      {
        path: 'my-account',
        component: () => import('@/views/tabs/AccountPage.vue')
      },
      {
        path: 'laboratory',
        component: () => import('@/views/laboratory/LaboratoryPage.vue'),
      },
      {
        path: 'library',
        component: () => import('@/views/library/LibraryPage.vue'),
      },
      {
        path: 'laboratory/:id',
        component: () => import('@/views/laboratory/LaboratoryViewPage.vue'),
      },
      {
        path: 'laboratory/new',
        component: () => import('@/views/laboratory/NewFragmentPage.vue')
      },
      {
        path: 'figures',
        component: () => import('@/views/laboratory/FiguresPage.vue'),
      },
      {
        path: 'figures/new',
        component: () => import('@/views/laboratory/addFigurePage.vue')
      },
      {
        path: 'combos',
        component: () => import('@/views/combos/CombosPage.vue'),
      },
      {
        path: 'combos/:id',
        component: () => import('@/views/combos/ComboViewPage.vue'),
      },
      // TODO: Habilitar cuando esté implementado (Favoritos)
      {
        path: 'my-favorites',
        component: () => import('@/views/FavoritesPage.vue')
      },
      {
        path: 'qr-generator',
        component: () => import('@/views/QrGeneratorPage.vue')
      },
      {
        path: 'change-password',
        component: () => import('@/views/Auth/ChangePasswordPage.vue')
      },
      {
        path: 'manage-users',
        component: () => import('@/views/ManageUsersPage.vue')
      },
      {
        path: 'manage-users/:uid',
        component: () => import('@/views/UserEditPage.vue'),
      },
      {
        path: 'manage-tricks',
        component: () => import('@/views/ManageTricksPage.vue')
      },
      {
        path: 'feedback',
        component: () => import('@/views/feedback/FeedbackPage.vue')
      },
      {
        path: 'blacklist',
        component: () => import('@/views/BlacklistPage.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Auth ya está resuelta cuando el router corre (main.ts awaita authReady antes de montar).
// Solo necesitamos verificar el estado del store.
router.beforeEach((to) => {
  if (!to.meta.authRequired) return true;
  if (!store.getters.getUser.loggedIn) return '/login';
});

export default router
